/*
 * @Descripttion: 订单关怀链路
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import React from 'react';
import {Balloon, Loading} from '@alifd/next';
import { history } from 'ice';
import utils from '../../utils';
import styles from './index.module.scss';
import { Servlets } from '@/service';

const LineBox = () => {
  const [textLoading, setTextLoading] = React.useState(false); // 表格loading
  const [activeList, setActiveList] = React.useState([]); // 激活列表
  const getStatus = async () => {
    await Servlets('getOrderTaskOpenStatus').then((res) => {
      if (!res.success) {
        setTextLoading(false);// 关闭loading
        return;
      }
      setActiveList(res.data ?? []);
      setTextLoading(false);// 关闭loading
    })
      .catch((err) => {
        console.log(err);
        setTextLoading(false);
      });
  };

  React.useEffect(() => {
    getStatus();
  }, []);

  const coundNotList = ['S_WLFH', 'S_TCTX', 'S_PJTX', 'S_QJTX', 'S_QSGH', 'S_WLYC', 'S_ZLTX']

  const renderIcon = (props) => {
    const type = props.realKey;
    // coundNotList.indexOf(props.realKey) === -1 ?
    return <div className={`${styles['icon-box']} ${styles['active']}`} onClick={() => {
        history.push(`./care/create/${type}/0`)
      }}>
        <div>
          {
            activeList.indexOf(type) > -1 && <span className={`iconfont icon-mianxingyuanquanduihao ${styles['top-right-icon']}`}></span>
          }
          <span className={`iconfont icon-qujiantixing ${styles['center-icon']} ${props.icon}`}></span>
        </div>
        <div>{props.label}</div>
      </div>
      // :
      // <div className={`${styles['icon-box']} ${styles['label']}`}>
      //   <div>
      //     <span className={`iconfont icon-qujiantixing ${styles['center-icon']} ${props.icon}`}></span>
      //   </div>
      //   <div className={styles['label-div']}>敬请期待</div>
      //   <div>{props.label}</div>
      // </div>
    // <Balloon.Tooltip
    //   popupClassName="popupClassName"
    //   align='t'
    //   trigger={

    //   }>
    //     <div>
    //       {
    //         props.desc1 && <div>
    //           <div>{`${props.desc1}的订单` ?? ''}</div>
    //           <div>{props.value1 ?? 0}</div>
    //         </div>
    //       }
    //       {
    //         props.desc2 && <div>
    //           <div>{`${props.desc2}的订单` ?? ''}</div>
    //           <div>{props.value2 ?? 0}</div>
    //         </div>
    //       }
    //     </div>
    // </Balloon.Tooltip>
  }
  return (
    <div className={styles['line-box-container']}>
      <Loading visible={textLoading} />

      <div className={styles['top-frame-box']}>
        <div className={styles['frame-line-one']}>
          <div className={styles['top-type']}>交易关怀</div>
        </div>
        <div className={styles['frame-line-two']}>
          <div className={styles['top-type']}>物流关怀</div>
        </div>
        <div className={styles['frame-line-three']}>
          <div className={styles['top-type']}>售后关怀</div>
        </div>
      </div>

      <div className={styles['center-line-node-list']}>
        <div className={styles['background-line']}> </div>
        {/* 这个地方应该循环的，不过等等看到时候鼠标移入展示具体订单数的功能到底做不做吧，做了的话后端返回又什么格式 */}
        {renderIcon({...utils.taskType['xdgh'], value1: 1, value2: 2, icon: 'icon-xiadanguanhuai1'})}
        {renderIcon({...utils.taskType['ddcf'], value1: 1, value2: 2, icon: 'icon-dingdancuifu'})}
        {renderIcon({...utils.taskType['fkgh'], value1: 1, value2: 2, icon: 'icon-fukuanguanhuai1'})}
        {renderIcon({...utils.taskType['sjfh'], value1: 1, value2: 2, icon: 'icon-shangjiafahuo'})}
        {renderIcon({...utils.taskType['wlfh'], value1: 1, value2: 2, icon: 'icon-wuliufahuo'})}
        {renderIcon({...utils.taskType['tctx'], value1: 1, value2: 2, icon: 'icon-tongchengtixing'})}
        {renderIcon({...utils.taskType['pjtx'], value1: 1, value2: 2, icon: 'icon-paijiantixing'})}
        {renderIcon({...utils.taskType['qjtx'], value1: 1, value2: 2, icon: 'icon-qujiantixing'})}
        {renderIcon({...utils.taskType['qsgh'], value1: 1, value2: 2, icon: 'icon-qianshouguanhuai'})}
        {renderIcon({...utils.taskType['wctx'], value1: 1, value2: 2, icon: 'icon-wanchengtixing'})}
        {renderIcon({...utils.taskType['ddcp'], value1: 1, value2: 2, icon: 'icon-dingdancuiping'})}
        {renderIcon({...utils.taskType['shsq'], value1: 1, value2: 2, icon: 'icon-shouhoushenqing'})}
        {renderIcon({...utils.taskType['tysh'], value1: 1, value2: 2, icon: 'icon-tongyishouhou'})}
        {renderIcon({...utils.taskType['shcg'], value1: 1, value2: 2, icon: 'icon-shouhouchenggong'})}
      </div>
      <div className={styles['bottom-line-node-list']}>
        <div style={{display: 'flex', width: '48%'}}>
          <div className={styles['node-div-one']}>
            <div className={styles['colume-line']}></div>
            <div>
              {renderIcon({...utils.taskType['yscf'], value1: 1, value2: 2})}
            </div>
          </div>
          <div className={styles['node-div-two']}>
            <div className={styles['colume-line']}></div>
            <div>
              {renderIcon({...utils.taskType['qxdd'], value1: 1, value2: 2})}
            </div>
          </div>
          <div className={styles['node-div-three']}>
            <div className={styles['colume-line']}></div>
            <div>
              {renderIcon({...utils.taskType['ycfh'], value1: 1, value2: 2})}
            </div>
          </div>
          <div className={styles['node-div-four']}>
            <div className={styles['colume-line']}></div>
            <div>
              {renderIcon({...utils.taskType['wlyc'], value1: 1, value2: 2})}
            </div>
          </div>
        </div>
        <div style={{width: '28%'}}>
          <div className={styles['node-div-five']}>
            <div className={styles['colume-line']}></div>
            <div>
              {renderIcon({...utils.taskType['zltx'], value1: 1, value2: 2})}
            </div>
          </div>
        </div>
        <div style={{width: '24%'}}>
          <div className={styles['node-div-six']}>
            <div className={styles['colume-line']}></div>
            <div>
              {renderIcon({...utils.taskType['jjsh'], value1: 1, value2: 2})}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LineBox;
